import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email-validator';

import { VendorInviteForm } from './vendor-invite-form';

export class InvitationContactForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined>;
  VendorInviteId: FormControl<number | undefined>;
  legalName: FormControl<string | null>;
  dba: FormControl<string | null>;
  email: FormControl<string | null>;
  address1: FormControl<string | null>;
  address2: FormControl<string | null>;
  city: FormControl<string | null>;
  state: FormControl<string | null>;
  zip: FormControl<string | null>;
  phone1: FormControl<string | null>;
  phone2: FormControl<string | null>;
  VendorInvite?: VendorInviteForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      VendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      VendorInviteId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      legalName: new FormControl<string | null>(null),
      dba: new FormControl<string | null>(null),
      email: new FormControl<string | null>(null, {
        validators: [Validators.required, emailValidator]
      }),
      address1: new FormControl<string | null>(null),
      address2: new FormControl<string | null>(null),
      city: new FormControl<string | null>(null),
      state: new FormControl<string | null>(null),
      zip: new FormControl<string | null>(null),
      phone1: new FormControl<string | null>(null),
      phone2: new FormControl<string | null>(null)
    });
  }
}
